import React, { useState } from 'react';

/**
 * Renders a user avatar: profile picture if available, or initials fallback.
 * Handles image load failures (e.g. 429 from Google) by falling back to initials.
 */
export function UserAvatar({ user, size = 'md', className = '' }) {
  const [imageError, setImageError] = useState(false);
  const showImage = user?.picture && !imageError;

  const sizeClasses = {
    sm: 'h-8 w-8 text-sm',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg',
  };
  const s = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`flex-shrink-0 rounded-full overflow-hidden bg-accent text-white flex items-center justify-center font-medium ${s} ${className}`}>
      {showImage ? (
        <img
          src={user.picture}
          alt=""
          className={`w-full h-full object-cover`}
          onError={() => setImageError(true)}
        />
      ) : (
        user?.name?.charAt(0) || 'U'
      )}
    </div>
  );
}
